export enum DataControlDataReach {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
  NONE = 'NONE',
}
